import Button from '../../Buttons/Button/Button';

import classes from './SuccessMessage.module.scss';

const SuccessMesage = ({ title, description, callback }) => {
  return (
    <div className={classes.content}>
      <span className='semibold-16'>{title}</span>

      <span className={classes.description}>{description}</span>

      <div className={classes.button}>
        <Button
          onClick={() => {
            if (callback) callback();
          }}
        >
          Entendido
        </Button>
      </div>
    </div>
  );
};

export default SuccessMesage;
